import { ReelItemMap, IItemTransform, IReelItem } from "../../../punkEngine/mapping/ReelItemMap";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { TimelineMax, Power3, Bounce, Timeline } from "gsap";
import { BLEND_MODES, Sprite } from "pixi.js";
import { ReelState } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../PunkGameConfig";
import { PunkEngineManager } from "../../../punkEngine/PunkEngineManager";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { PunkSymbol } from "../../../punkEngine/PunkSymbol";
import { PunkEngineController } from "../../../punkEngine/PunkEngineController";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TranslationConfig } from "../../../translations/TranslationConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { FontStyle, FontWeight } from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";

export class ReelOverlayState{
    public static readonly ATTENTION:string = "Sector_Attention";
    public static readonly IGNITE:string = "WildIgnite";
    public static readonly FIRE:string = "WildFire";
    public static readonly JUMP_FIRE:string = "JumpFire";
}

export interface IReelItemOverlay extends IReelItem {
    seqAnimations:Sequence[];
    glowSprite:Sprite;
    ReelFakeSymbol:Sprite;
    repeater:TimelineMax;
    lightTime:TimelineMax;
    sizeTime:TimelineMax;
}

export class ReelItemOverlay extends ReelItemMap {

    private static _instance:ReelItemOverlay;
    protected _items:IReelItemOverlay[] = [];

    protected readonly _symbolArrSizes:number[] = [90,108,135,180,270,324,360];
    protected readonly animationSizeY:number = 90;

    protected _reelStopped:boolean = false;

    protected sTimline:TimelineMax;

    public set reelStopped(value:boolean){
        this._reelStopped = value;
    }

    constructor(){
        super();
        if(!ReelItemOverlay._instance){
            ReelItemOverlay._instance = this;
            StageManager.getLayer(PunkGameConfig.instance.LAYERS.REEL_OVERLAY.name).addChild(this);
        } 
    }

    public static get instance():ReelItemOverlay{ return this._instance; }

    public lightPosition(reelId:number,symId:number,duration:number, intensity:number):TimelineMax{
        const target: IReelItemOverlay = this.getItem(reelId, symId);
        target.lightTime = Helper.timeLineKiller(target.lightTime,new TimelineMax());
        const slicedDurr: number = duration * 0.5;

        const alphaFrom:number = target.glowSprite.alpha;
        const alphaMax:number = Math.min(intensity*1.6 ,1);
        target.lightTime.fromTo(target.glowSprite,slicedDurr, {alpha: alphaFrom}, {alpha: alphaMax, ease:Power3.easeOut})
        target.lightTime.to(target.glowSprite,slicedDurr,{alpha: intensity})

        return target.lightTime;
    }

    public nearWinSpot(reelId:number,symId:number, duration:number,active:boolean, delay:number = 0):TimelineMax{
        const target:IReelItemOverlay = this.getItem(reelId,symId);
        target.lightTime = Helper.timeLineKiller(target.lightTime,new TimelineMax());
        const slicedDurr: number = duration * 0.5;
        target.lightTime.delay(delay);
        if(active){
            target.lightTime.fromTo(target.glowSprite,slicedDurr,{alpha: 0}, {alpha:  0.4 , ease:Power3.easeOut})
            target.lightTime.to(target.glowSprite,slicedDurr,{alpha: 0.3})
        }else
            target.lightTime.to(target.glowSprite,duration,{alpha:0, ease:Power3.easeOut})
        return target.lightTime;
    }

    public flashSymbol(reelId:number,symId:number, duration:number,active:boolean):void{
        const target: IReelItemOverlay = this.getItem(reelId, symId);
        target.ReelFakeSymbol.alpha = 0;
        target.repeater = Helper.timeLineKiller(target.repeater,new TimelineMax());
        if(!active) return;
        
        target.repeater.add(() => target.ReelFakeSymbol.alpha = 1 );
        target.repeater.to(target.ReelFakeSymbol,duration*0.9,{alpha: 0})
        target.repeater.play();
    }

   

    public playAnimation(reelId:number,symId:number, state:string, duration?:number):TimelineMax{
        const target:IReelItemOverlay = this.getItem(reelId,symId);
        const seq:Sequence = this.fetchSequence(target);
        seq.alpha = 0;
        if(state == ReelOverlayState.JUMP_FIRE) seq.scale.set(2,2);
        else seq.scale.set(1,1);
        
        seq.setTexture(GameResources.getTextures(state))
        return seq.playAnimation({onCompleteCallback:() => seq.alpha = 0, onStart:() => seq.alpha = 1,   duration:duration});
    }

    private readonly _styleWays:TextStyleOptions = {
        fontFamily : "Helvetica",
        fontStyle : FontStyle.ITALIC,
        fontSize : 16,
        fontWeight : FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 8,
        fill: "#FFFFFF",
        lineJoin: "round",
        stroke: "#FF2600",
        strokeThickness: 8
    };


    public playValueText(reelId:number,symId:number, val: number,waysValue:number): TimelineMax {
        let target = this.getItem(reelId, symId).ReelFakeSymbol as PIXI.Sprite;

        const cont =  StageManager.getLayer(PunkGameConfig.instance.LAYERS.BIG_WIN.name);


        const currValue:string  = SlotGame.api.currency.formatValue(val)
        const txt: PIXI.Text | PIXI.BitmapText = cont.addChild(new PIXI.BitmapText(currValue, { 
            fontName: "NumbersWinCountUp",
            fontSize: 20,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        }));
        txt.anchor = new PIXI.Point(0.5, 0.4);

        const txtWays = cont.addChild(new PIXI.Text(""));
        txtWays.style = this._styleWays;
        txtWays.anchor.set(0.5, 0.4);
        txtWays.pivot.y = -60;
        txtWays.text = waysValue.toString() + " " + Translation.translate((waysValue == 1 ? TranslationConfig.WAY_WON : TranslationConfig.WAYS_WON));
        txtWays.updateTransform();

        txt.zIndex = 5000;
        cont.sortChildren();

        const startPos: PIXI.Point = Helper.copyLocalPosition(txt, target)
        const heightYDirr: number = 60;

        txt.alpha = 0;
        txtWays.alpha = 0;
      
        txt.position = startPos;
        txtWays.position = startPos;

        const up: number = startPos.y - heightYDirr;

        const moveDurr: number = 0.8;
        const scaleDurr: number = 0.3;
        const alphaDurr: number = 0.25;

        const tl: TimelineMax = new TimelineMax({
            onComplete: () => { if(txt && txt.transform) txt.destroy({ children: true }) }
        });

        const animate:PIXI.DisplayObject[] = [txt,txtWays];

        tl.to(animate,alphaDurr, { alpha: 1, ease:Power3.easeIn }, 0);
        tl.to(animate,moveDurr*0.75, { y: up}, 0);
        animate.forEach(item => {
            tl.fromTo(item.scale,scaleDurr, { x: 0.35, y: 0.35 }, { x: 1, y: 1 }, 0);
        })
        tl.to(animate,alphaDurr, { alpha: 0 }, "-="+alphaDurr)
        return tl;
    }

    public fadeGlowState(ReelId:number, val:boolean, duration:number):void{
        // const tl:TimelineMax = new TimelineMax({onComplete:() => val ? {} : this.reset()});
        // this.sTimline = Helper.timeLineKiller(this.sTimline, new TimelineMax())
        const alphaFrom:number = val ? 0 : 1;
        const alphaTo:number = val ? 1 : 0;
        for(let symID:number = 0; symID < PunkEngineManager.getReel(ReelId).windowAmount;symID++){
            const target:IReelItemOverlay = this.getItem(ReelId, symID);
            target.lightTime = Helper.timeLineKiller(target.lightTime,new TimelineMax());
            target.lightTime.fromTo(target.glowSprite,duration,{alpha:alphaFrom},{alpha:alphaTo},0)
            // this.updateItemTransform(target);
        }
    }

    public fadeState(val:boolean, duration:number):TimelineMax{
        // const tl:TimelineMax = new TimelineMax({onComplete:() => val ? {} : this.reset()});
        this.sTimline = Helper.timeLineKiller(this.sTimline, new TimelineMax())
        const alphaFrom:number = val ? 0 : 1;
        const alphaTo:number = val ? 1 : 0;
        PunkEngineManager.RSWindow((reelID:number, symId:number) => {
            const target:IReelItemOverlay = this.getItem(reelID,symId);
            this.sTimline.fromTo(target.glowSprite,duration,{alpha:alphaFrom},{alpha:alphaTo, ease:Power3.easeOut},0)
            // this.updateItemTransform(target);
        })
        return this.sTimline;
    }

    public changeSizeBg(reelId:number,symId:number,duration:number = 0.25):TimelineMax{
        const target: IReelItemOverlay = this.getItem(reelId, symId);
        target.sizeTime = Helper.timeLineKiller(target.sizeTime,new TimelineMax());

        const symbol:PunkSymbol = PunkEngineManager.getReel(target.ReelID).getSymbol(target.SymID)!;
        const currHeight:number = this._symbolArrSizes[symbol.stateType.state];
        const nextHeight:number = this._symbolArrSizes[symbol.stateType.state-1];
        target.sizeTime.to(target,duration,{ onUpdate:() => target.glowSprite.position = Helper.copyLocalPosition(target.glowSprite, symbol)
            ,ease:Bounce.easeOut},0)
        target.sizeTime.fromTo(target.glowSprite, duration, { height: currHeight }, { height:nextHeight, ease:Bounce.easeOut },0);
        target.sizeTime.play();
        return target.sizeTime;
    }
   
    protected fetchSequence(item:IReelItemOverlay):Sequence{
        for(let i:number = 0; i < item.seqAnimations.length;i++){
            if(!item.seqAnimations[i].isActive) return item.seqAnimations[i];
        }
        const seq:Sequence = new Sequence({textures: GameResources.getTextures("Sector_Attention")});
        this.addChild(seq);
        seq.alpha = 0;
        seq.blendMode = BLEND_MODES.ADD;
        seq.anchor.set(0.5,0.5);
        item.seqAnimations.push(seq);
        this.updateItemTransform(item);
        return seq;
    }

    protected getItem(reelID:number,symID:number):IReelItemOverlay{
        if(this.getExistingItem(reelID, symID)){
            const item:IReelItemOverlay = this.getExistingItem(reelID, symID)!;
            this.updateItemTransform(item);
            return item;
        }

        const sp:Sprite = createSP("Sector_Attention");
        const spSym:Sprite = createSP("M/4/M_normal");
        let item:IReelItemOverlay =  this.createItem(reelID, symID,{lightTime: new TimelineMax(),sizeTime: new TimelineMax(),seqAnimations:[], glowSprite:sp, ReelFakeSymbol:spSym, repeater:new TimelineMax()});

        this.addChild(sp);
        this.addChild(spSym);
        this._items.push(item);
        this.updateItemTransform(item);
        return item;

        function createSP(texturePath:string):PIXI.Sprite{
            const sp = new Sprite(GameResources.getTextures(texturePath)[0]);
            sp.alpha = 0;
            sp.blendMode = BLEND_MODES.ADD;
            sp.pivot.set(0,0);
            sp.anchor.set(0.5,0.5);
            return sp;
        }
    }
 
    // Functions
    protected updateItemTransform(item:IReelItemOverlay):void{
        if(item == undefined) return;

        const reelState = this._reelStopped || PunkEngineManager.getReel(item.ReelID).state.isIdle ? ReelState.IDLE : ReelState.STEP;
        const transformData:IItemTransform =  this.getTransformData(item, item.glowSprite, reelState)!;

        const scriptHeight:number = [360, 324, 270, 180, 135, 108, 90][PunkEngineManager.getReel(item.ReelID).windowAmount];
        const height:number = reelState == ReelState.STEP ? scriptHeight :  this.getSymbolTransformData(item, item.glowSprite, true, reelState)!.height ;

        const scaleY:number = PunkEngineManager.dim.scale.y * (height/transformData.height);
        const scaleX:number = PunkEngineManager.dim.scale.x;

        item.glowSprite.scale.set(scaleX,scaleY);
        item.glowSprite.position = transformData.position;

        item.ReelFakeSymbol.scale.set(scaleX,scaleY);
        item.ReelFakeSymbol.position = transformData.position;

        for(let i:number = 0; i < item.seqAnimations.length;i++){
            const transformData2:IItemTransform =  this.getSymbolTransformData(item, item.seqAnimations[i], true, reelState)!;
            item.seqAnimations[i].position = transformData2.position;
            item.seqAnimations[i].scale = transformData2.scale;
        }
    }

    protected getTransformData(item:IReelItem, displayObj?:PIXI.DisplayObject, stateType?:string):IItemTransform | undefined{
        const reelC:PunkEngineController = PunkEngineManager.getReel(item.ReelID);
        return {
            position: reelC.getCurrentStatePositionMap(displayObj ? displayObj : this, stateType)[item.SymID + reelC.overflowDirection],// PunkGameConfig.instance.REEL_ENGINE_CONFIG.OVERFLOW_TOP + PunkGameConfig.instance.REEL_ENGINE_CONFIG.RESULT_OVERFLOW],
            scale: PunkEngineManager.dim.scale,
            width: 110,
            height: 180
        }
    }

    // Overrides
    protected createItem(reelID:number,symID:number, obj:Object):IReelItemOverlay{
        return super.createItem(reelID,symID, obj) as IReelItemOverlay;
    }
    
    protected getExistingItem(reelID:number, symID:number):IReelItemOverlay | undefined{
        return super.getExistingItem(reelID,symID) as IReelItemOverlay;
    }
}